import { render, staticRenderFns } from "./priceChangeDetails.vue?vue&type=template&id=4d038fde"
import script from "./priceChangeDetails.vue?vue&type=script&lang=js"
export * from "./priceChangeDetails.vue?vue&type=script&lang=js"
import style0 from "./priceChangeDetails.vue?vue&type=style&index=0&id=4d038fde&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports